import { TagKindSchema } from "@redotech/redo-model/tag";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const deleteTag = {
  name: "deleteTag" as const,
  input: z.object({ name: z.string(), kind: TagKindSchema }),
  output: zNull(),
};
